const dataWork = [
  {
    id: 1,
    company: "Modelon",
    image: require("../assets/images/Works/Work1.png"),
    title: "Student Intern",
    duration: "Summer Internship",
    period: "Jun 2023 - July 2023",
    describe:
      "Automated UI Testing with Selenium Webdriver and Cucumber, orchestrating over 30 test cases and 5 scenarios.\nEnhanced data post-processing with visualization extension using plotly.js, impacting efficiency metrics.\nImplemented web scraping, avoids harcoding and reducing UI testing code maintenance overhead by 60%.",
  },
  {
    id: 2,
    company: "Modelon",
    image: require("../assets/images/Works/internship2.png"),
    title: "SDE Intern",
    duration: "6 months",
    period: "since Jan 2024",
    describe:
      "Engineered a React.js and D3.js tool, enabling users to visualize and customize post-processing data.\nAdvocated for WebGL adoption over SVG, resulting in a 50% performance enhancement in plotting of large data.\nSpearheaded the development of a project utilizing React's modular component architecture.",
  },
];

export default dataWork;
